export default {
  search          : false,
  showColumns     : true,
  showRefresh     : true,
  buttonsAlign    : 'left',
  buttonsToolbar  : '#toolbar',
  pagination      : true,
  sidePagination  : 'server',
  locale          : 'pt-BR',
  showExport      : false,
  pageList        : '[25, 100, 200, All]',
  pageSize        : '25',
  paginationVAlign: 'both'
}
